import reducer from './reducers';

import * as themeOperations from './operations';

export {
    themeOperations
};

export default reducer;
